/* NP社内修正 (株式会社ニューポート)
   08-21 初版 / 08-22 カートUI・進捗バー / 08-23 商品ページ送料表示・cart.js連打停止・Paidy位置整理
   08-24 安心情報 / 容量あたり単価
   09-16 送料表示の文言を短縮（Fix-10 / Fix-9）：
         ¥10,000未満は「送料 ¥440（¥10,000以上で無料）」＋残額、以上は「送料無料」のみ
   09-17 3STEPサンプルセット（配送プロファイル「サンプルセット送料無料」）は金額に関係なく「送料無料」。
         PDPがこの商品のとき／カートの全ラインがこの商品のときに適用（混在時は従来どおり）。
         PDPの送料行の下に「公式オンラインショップ・正規品」を1行追加（.np-pdp-ship__auth）。

   Fix-3 検索URL正規化 / Fix-4 スライドクリック / Fix-8 カート整理 / Fix-9 カート進捗バー
   Fix-10 商品ページ送料表示 / Fix-11 cart.js ポーリング抑止 / Fix-12 Paidyを価格直下へ
   Fix-19 商品ページの安心情報（発送・返品） / Fix-20 容量あたり単価
   Guard-1 サンプル自動付与 / Guard-2 配送日時重複排除

   【触らないこと】
   .cart__delivery（配送希望日時選択）は折りたたまない。
   2026-08-24 に一度 makeAccordion の対象にしたが、
   閉じている間は中のカレンダーUIが見えなくなり、
   日時指定の入力漏れを招くため即日撤回した。
   カートの縦長さを縮める別手段を検討すること。

   ※ CSSは np-cart-progress.css と np-pdp-layout.css。 */
(function () {
  // ▼ 設定
  var NP_CART_MILESTONES = [
    { amount: 10000, label: '送料無料' }
  ];
  var NP_SHIPPING_FEE = 440;   // 送料無料未満の送料（全国一律・沖縄も同額）
  var NP_FREE_SHIP_PRODUCT_ID = 9276848013543;   // 3STEP洗顔 お試しサンプルセット（variant 51169265025255）：常に送料無料
  var NP_AUTH_TEXT = '公式オンラインショップ・正規品';
  var NP_PAIDY_MIN = 3000;     // Paidy 3回あと払いの下限（実測で確認）
  var NP_DISPATCH_TEXT = '在庫がある場合、原則３営業日以内に発送';
  var NP_RETURN_TEXT = '商品到着後14日以内のご連絡で返品・交換可';
  var NP_RETURN_URL = '/policies/refund-policy';
  // ▲ 設定ここまで

  var yen = function (n) {
    try { return '¥' + Number(n).toLocaleString('ja-JP'); } catch (e) { return '¥' + n; }
  };
  var nb = function (s) { return '<span class="np-nb">' + s + '</span>'; };
  /* カートの全ラインが送料無料商品（3STEPサンプル）か */
  var isAllSampleCart = function (cart) {
    var items = cart && cart.items;
    if (!items || !items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].product_id) !== NP_FREE_SHIP_PRODUCT_ID) return false;
    }
    return true;
  };
  var isPdp = function () { return /\/products\//.test(location.pathname); };

  // ---- Fix-3 ----
  try {
    if (location.pathname.replace(/\/$/, '') === '/search') {
      var sp = new URLSearchParams(location.search);
      if (sp.get('q') && !sp.get('type')) {
        sp.set('type', 'product');
        location.replace(location.pathname + '?' + sp.toString());
      }
    }
  } catch (e) { console.warn('[NP-Fix] search normalize error', e); }

  // ---- Guard-1 ----
  (function filterSampleRules() {
    if (!Array.isArray(window.sampleRules)) return;
    window.sampleRules = window.sampleRules.filter(function (r) {
      var p = parseInt(r.sample_price, 10);
      if (!isNaN(p) && p > 0) {
        console.warn('[NP-Fix] サンプルルール「' + r.rule_name + '」は0円商品でないため無効化');
        return false;
      }
      return true;
    });
  })();

  // ---- Guard-2 ----
  function neutralize(el) {
    if (!el || el.dataset.npNeutralized === '1') return;
    el.dataset.npNeutralized = '1';
    el.style.setProperty('display', 'none', 'important');
    el.querySelectorAll('input,select,textarea').forEach(function (f) {
      if (f.name) { f.setAttribute('data-np-original-name', f.name); f.removeAttribute('name'); }
      f.disabled = true;
    });
  }

  function dedupeDeliveryWidgets() {
    var themeMount = document.querySelector('.cart_appBlock .calendarMaster__datePicker, .cart__delivery .calendarMaster__datePicker');
    if (themeMount) {
      document.querySelectorAll('.calendarMaster__autoInstall, .calendarMaster__autoInstall-wrapper').forEach(function (el) {
        if (el.querySelector('input,select')) neutralize(el);
      });
    }
    [['.calendarMaster__datePicker', '.calendarMaster__datePicker-wrapper'],
     ['.calendarMaster__timeSelect', '.calendarMaster__timeSelect-wrapper']].forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (box) {
        box.querySelectorAll(':scope > ' + pair[1]).forEach(function (w, i) { if (i > 0) neutralize(w); });
      });
    });
  }

  // ---- Fix-8 ----
  function makeAccordion(panel, openByDefault) {
    if (!panel || panel.classList.contains('np-acc')) return;
    var heading = panel.querySelector(':scope > .cart__panel-heading');
    var body = panel.querySelector(':scope > .cart__panel-body');
    if (!heading || !body) return;
    panel.classList.add('np-acc');
    if (openByDefault) panel.classList.add('np-open');
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', openByDefault ? 'true' : 'false');
    function toggle() {
      var open = panel.classList.toggle('np-open');
      heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  function enhanceCart() {
    var options = document.querySelector('.cart__checkout-options');
    if (!options) return;
    var couponSection = document.querySelector('[id$="custom_liquid_kMdGNM"]');
    if (couponSection && !document.querySelector('.np-coupon')) {
      var panel = document.createElement('div');
      panel.className = 'cart__panel np-coupon';
      var h = document.createElement('h2');
      h.className = 'cart__panel-heading';
      h.textContent = 'ポイントをクーポンに交換する';
      var body = document.createElement('div');
      body.className = 'cart__panel-body';
      panel.appendChild(h); panel.appendChild(body);
      options.insertBefore(panel, options.firstChild);
      body.appendChild(couponSection);
      makeAccordion(panel, false);
    }
    makeAccordion(document.querySelector('.cart__notices'), false);
    makeAccordion(document.querySelector('.cart__note'), false);

    /* 配送希望日時選択は折りたたまない。
       閉じている間はカレンダーUIが見えなくなり、
       日時指定の入力漏れを招くため（2026-08-24 撤回）。
       並び順の整理だけ行う。 */
    var delivery = document.querySelector('.cart__delivery');
    if (delivery && delivery.parentElement === options && options.lastElementChild !== delivery) {
      options.appendChild(delivery);
    }
    var noteHost = document.querySelector('cart-note.cart__note-component');
    if (noteHost && delivery && noteHost.parentElement === options) {
      options.insertBefore(noteHost, delivery);
    }
  }

  // ---- Fix-9 ----
  function renderProgress(total, cart) {
    var totals = document.querySelector('.cart-summary__inner > .cart-totals');
    if (!totals || !NP_CART_MILESTONES.length) return;
    var box = document.querySelector('.np-progress');
    if (!box) {
      box = document.createElement('div');
      box.className = 'np-progress';
      box.innerHTML =
        '<p class="np-progress__message"></p>' +
        '<div class="np-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100">' +
        '<div class="np-progress__fill" style="width:0%"></div></div>' +
        '<div class="np-progress__labels"></div>';
      totals.parentElement.insertBefore(box, totals);
    }
    var max = NP_CART_MILESTONES[NP_CART_MILESTONES.length - 1].amount;
    var allSample = isAllSampleCart(cart);   // 全ラインが3STEPサンプル → 金額に関係なく達成扱い
    var pct = allSample ? 100 : Math.max(0, Math.min(100, (total / max) * 100));
    var next = null;
    if (!allSample) {
      for (var i = 0; i < NP_CART_MILESTONES.length; i++) {
        if (total < NP_CART_MILESTONES[i].amount) { next = NP_CART_MILESTONES[i]; break; }
      }
    }
    var msg = box.querySelector('.np-progress__message');
    if (next) {
      msg.className = 'np-progress__message';
      msg.innerHTML = 'あと <span class="np-progress__amount">' + yen(next.amount - total) + '</span> で' + next.label;
    } else {
      msg.className = 'np-progress__message np-progress__message--done';
      msg.innerHTML = '<span class="np-progress__amount">' + NP_CART_MILESTONES[NP_CART_MILESTONES.length - 1].label + '</span>';
    }
    box.classList.toggle('np-progress--done', !next);
    var track = box.querySelector('.np-progress__track');
    track.setAttribute('aria-valuenow', Math.round(pct));
    box.querySelector('.np-progress__fill').style.width = pct + '%';
    track.querySelectorAll('.np-progress__marker').forEach(function (m) { m.remove(); });
    var labels = box.querySelector('.np-progress__labels');
    labels.innerHTML = '';
    NP_CART_MILESTONES.forEach(function (m, idx) {
      var left = (m.amount / max) * 100;
      var reached = allSample || total >= m.amount;
      var dot = document.createElement('span');
      dot.className = 'np-progress__marker' + (reached ? ' np-progress__marker--reached' : '');
      dot.style.insetInlineStart = left + '%';
      track.appendChild(dot);
      var lab = document.createElement('span');
      lab.className = 'np-progress__label' + (reached ? ' np-progress__label--reached' : '');
      lab.style.insetInlineStart = left + '%';
      if (idx === NP_CART_MILESTONES.length - 1 && left >= 99) lab.setAttribute('data-edge', 'end');
      if (left <= 1) lab.setAttribute('data-edge', 'start');
      lab.textContent = yen(m.amount) + ' ' + m.label;
      labels.appendChild(lab);
    });
  }

  /* ---- Fix-10: 商品ページの送料表示 ---- */
  function renderPdpShipping(total, product) {
    var host = document.querySelector('.product-form-buttons');
    if (!host || !host.parentElement) return;
    var box = document.querySelector('.np-pdp-ship');
    if (!box) {
      box = document.createElement('div');
      box.className = 'np-pdp-ship';
      host.parentElement.insertBefore(box, host);
    }
    var th = NP_CART_MILESTONES[0].amount;
    var lead, main, sub;

    /* 2026-09-16 文言を短縮。
       ・¥10,000以上   ：「送料無料」だけ（説明文なし）
       ・¥10,000未満／空：「送料 ¥440（¥10,000以上で無料）」。カートに何か入っていれば残額を補足
       2026-09-17 3STEPサンプルの商品ページは金額に関係なく「送料無料」だけ。 */
    var isSampleProduct = !!(product && Number(product.id) === NP_FREE_SHIP_PRODUCT_ID);
    if (isSampleProduct || total >= th) {
      box.className = 'np-pdp-ship np-pdp-ship--done';
      lead = '送料無料';
      main = '';
      sub = '';
    } else {
      box.className = 'np-pdp-ship';
      lead = '送料';
      main = '<b>' + nb(yen(NP_SHIPPING_FEE)) + '</b>' + nb('（' + yen(th) + '以上で無料）');
      sub = total > 0 ? 'あと <b>' + nb(yen(th - total)) + '</b> ' + nb('で送料無料') : '';
    }

    box.innerHTML =
      '<span class="np-pdp-ship__lead">' + lead + '</span>' +
      (main ? '<span class="np-pdp-ship__main">' + main + '</span>' : '') +
      (sub ? '<span class="np-pdp-ship__sub">' + sub + '</span>' : '') +
      '<span class="np-pdp-ship__auth">' + nb(NP_AUTH_TEXT) + '</span>';
  }

  /* ---- Fix-19: 安心情報（発送・返品）---- */
  function renderTrust() {
    if (!isPdp()) return;
    var host = document.querySelector('.product-form-buttons');
    if (!host || !host.parentElement) return;
    if (document.querySelector('.np-trust')) return;
    var box = document.createElement('div');
    box.className = 'np-trust';
    box.innerHTML =
      '<span class="np-trust__item">' + nb(NP_DISPATCH_TEXT) + '</span>' +
      '<span class="np-trust__item">' + nb(NP_RETURN_TEXT) +
        ' <a href="' + NP_RETURN_URL + '">' + nb('条件を見る') + '</a></span>';
    host.parentElement.insertBefore(box, host.nextSibling);
  }

  /* ---- Fix-12 / Fix-20 共通：現在のバリエーション ---- */
  var productJson = null;

  function fetchProductJson() {
    if (productJson) return Promise.resolve(productJson);
    var url = location.pathname.split('?')[0].replace(/\/$/, '') + '.js';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { productJson = p; return p; });
  }

  function currentVariant() {
    var input = document.querySelector('.product-form-buttons input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
    var id = input && Number(input.value);
    return fetchProductJson().then(function (p) {
      if (!p || !p.variants) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (!id || p.variants[i].id === id) return p.variants[i];
      }
      return p.variants[0] || null;
    });
  }

  function currentVariantPrice() {
    return currentVariant().then(function (v) {
      return v ? Math.round(v.price / 100) : null;
    });
  }

  /* ---- Fix-20: 容量あたり単価 ---- */
  var unitLastVariant = null;

  function renderUnitPrice() {
    if (!isPdp()) return;
    var priceEl = document.querySelector('.product-information product-price, product-price');
    if (!priceEl || !priceEl.parentElement) return;
    var host = document.querySelector('.np-unit');
    if (!host) {
      host = document.createElement('span');
      host.className = 'np-unit';
      host.hidden = true;
      priceEl.parentElement.insertBefore(host, priceEl.nextSibling);
    }
    currentVariant().then(function (v) {
      if (!v) { host.hidden = true; return; }
      if (String(v.id) === unitLastVariant) return;
      unitLastVariant = String(v.id);
      var m = String(v.title || '').match(/([0-9]+(?:\.[0-9]+)?)\s*(mL|ml|ML|g|G)(?![A-Za-z])/);
      if (!m) { host.hidden = true; return; }
      var vol = parseFloat(m[1]);
      if (!vol) { host.hidden = true; return; }
      var unit = /^g$/i.test(m[2]) ? 'g' : 'mL';
      var per = (v.price / 100) / vol;
      var shown = per >= 100 ? Math.round(per) : Math.round(per * 10) / 10;
      host.hidden = false;
      host.textContent = '1' + unit + 'あたり ' + yen(shown) + '（税込）';
    }).catch(function (e) { console.warn('[NP-Fix] unit price error', e); });
  }

  /* ---- Fix-12: Paidy を価格の直下へ ---- */
  var paidyLastPrice = null;

  function paidyRescan() {
    var s = document.createElement('script');
    s.src = 'https://cdn.paidy.com/promotional-messaging/general/paidy-upsell-widget.js';
    s.async = true;
    document.body.appendChild(s);
  }

  function arrangePaidy() {
    if (!isPdp()) return;
    var priceEl = document.querySelector('.product-information product-price, product-price');
    if (!priceEl || !priceEl.parentElement) return;

    var host = document.querySelector('.np-paidy');
    if (!host) {
      host = document.createElement('div');
      host.className = 'np-paidy';
      priceEl.parentElement.insertBefore(host, priceEl.nextSibling);
    }

    var widget = document.querySelector('._paidy-promotional-messaging');
    if (widget && widget.parentElement !== host) host.appendChild(widget);

    currentVariantPrice().then(function (price) {
      if (price === null || price === paidyLastPrice) return;
      paidyLastPrice = price;

      if (price < NP_PAIDY_MIN) {
        host.hidden = true;
        return;
      }

      host.hidden = false;
      var w = host.querySelector('._paidy-promotional-messaging');
      if (!w) {
        w = document.createElement('span');
        w.className = '_paidy-promotional-messaging';
        w.setAttribute('data-amount', String(price));
        host.appendChild(w);
        paidyRescan();
        return;
      }
      if (String(w.getAttribute('data-amount') || '').replace(/[^0-9]/g, '') !== String(price)) {
        var fresh = document.createElement('span');
        fresh.className = '_paidy-promotional-messaging';
        fresh.setAttribute('data-amount', String(price));
        w.replaceWith(fresh);
        paidyRescan();
      }
    }).catch(function (e) { console.warn('[NP-Fix] paidy arrange error', e); });
  }

  /* ---- Fix-11: cart.js の連打抑止 ----
     ガードを fetch の前に置くこと。後ろに置くと毎秒叩きになります。 */
  var inFlight = false;
  var needsFetch = true;

  function refreshTotals() {
    var onCart = !!document.querySelector('.cart-summary__inner > .cart-totals');
    var onPdp = isPdp() && !!document.querySelector('.product-form-buttons');
    if (!onCart && !onPdp) return;
    var painted = (onCart && document.querySelector('.np-progress')) || (onPdp && document.querySelector('.np-pdp-ship'));
    if (inFlight) return;
    if (!needsFetch && painted) return;

    inFlight = true;
    needsFetch = false;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = Math.round((cart.total_price || 0) / 100);
        if (onCart) renderProgress(total, cart);
        if (onPdp) {
          // 商品IDは /products/handle.js から取得（productJson はキャッシュされる）
          return fetchProductJson()
            .then(function (p) { renderPdpShipping(total, p); })
            .catch(function () { renderPdpShipping(total, null); });
        }
      })
      .catch(function (e) { needsFetch = true; console.warn('[NP-Fix] cart fetch error', e); })
      .then(function () { inFlight = false; });
  }

  var npFixTimer;
  function runAll() {
    dedupeDeliveryWidgets();
    enhanceCart();
    arrangePaidy();
    renderUnitPrice();
    refreshTotals();
    renderTrust();
  }
  function schedule() {
    clearTimeout(npFixTimer);
    npFixTimer = setTimeout(runAll, 200);
  }

  ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { needsFetch = true; schedule(); });
  });
  ['variant:update', 'variant:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { schedule(); });
  });

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // ---- Fix-4 ----
  (function enableClonedSlideLinks() {
    var downX = null;
    document.addEventListener('mousedown', function (e) {
      var t = e.target.closest ? e.target.closest('[data-slideshow-track]') : null;
      downX = t ? e.clientX : null;
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var slide = e.target.closest('.slideshow-top-slide');
      if (!slide) return;
      if (e.target.closest('a, button')) return;
      if (downX !== null && Math.abs(e.clientX - downX) > 5) return;
      var link = slide.getAttribute('data-slide-link');
      if (!link) return;
      window.location.href = link;
    });
  })();
})();
